import {ColumnsType} from "antd/es/table";
import {StyledDescriptionText} from "../../../calls/upcoming-calls/upcoming-calls.style";
import {ServiceListMenuOption} from "./menu-options";
import {Button, Space, Table} from "antd";
import {GetStoreServicesApiResponse} from "../../../../react-query-hooks/store/services/get-services/types";
import {Dispatch, useState} from "react";
import {PaginationMeta} from "../../../../redux/service/i-service";
// import {use} from "react";

interface DataType {
  key: number;
  id: number;
  image: string;
  name: string;
  price: number;
  currency: string;
  ordersInProgress: number;
  tinyUrl: string;
  slug: string;
  statusId: number;
  ordersCompleted: number;
  revenue: string;
}

export type ServiceListTableProps = {
  data: GetStoreServicesApiResponse["productServices"];
  isPreviousData: boolean;
  isLoading: boolean;
  paginationMeta: PaginationMeta;
  setCurrentPage: Dispatch<React.SetStateAction<number>>;
  currentPage: number;
};

export function ServiceListTable({
  data,
  isPreviousData,
  paginationMeta,
  isLoading,
  setCurrentPage,
  currentPage,
}: ServiceListTableProps) {
  console.log({paginationMeta});

  const serviceData: DataType[] = data.map((s) => ({
    currency: s.currency,
    id: s.id,
    image:
      s.cover_images.length > 0
        ? s.cover_images[0].media_url
        : "/images/no-image-placeholder.png",
    key: s.id,
    name: s.name,
    ordersCompleted: s.ordersCompleted,
    ordersInProgress: s.ordersPending,
    price: s.amount,
    revenue: s.revenue,
    slug: s.slug,
    statusId: s.statusId,
    tinyUrl: s.tiny_url,
  }));

  const columns: ColumnsType<DataType> = [
    {
      title: "Service name",
      dataIndex: "name",
      fixed: "left",
      width: "180px",
      key: "name",
      render: (value, record) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          <div
            style={{
              width: "4.4rem",
              height: "2.2rem",
            }}
          >
            <img
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "2px",
              }}
              src={record.image}
              alt={value}
            />
          </div>
          <StyledDescriptionText style={{textTransform: "capitalize"}}>
            {value}
          </StyledDescriptionText>
        </div>
      ),
    },
    {
      title: "Price",
      dataIndex: "price",
      width: "150px",
      key: "price",
      render: (value: number, record) => (
        <>
          {value === 0 ? (
            <StyledDescriptionText>Free</StyledDescriptionText>
          ) : (
            <StyledDescriptionText>{`${
              record.currency
            } ${value.toLocaleString()}`}</StyledDescriptionText>
          )}
        </>
      ),
    },
    {
      title: "Orders in progress",
      dataIndex: "ordersInProgress",
      width: "130px",
      key: "ordersInProgress",
      render: (value: number) => (
        <>
          <StyledDescriptionText>{value.toLocaleString()}</StyledDescriptionText>
        </>
      ),
    },
    {
      title: "Orders completed",
      dataIndex: "ordersCompleted",
      width: "130px",
      key: "ordersCompleted",
      render: (value: number) => (
        <>
          <StyledDescriptionText>{value.toLocaleString()}</StyledDescriptionText>
        </>
      ),
    },
    {
      title: "Revenue",
      dataIndex: "revenue",
      width: "150px",
      key: "revenue",
      render: (value) => (
        <>
          <StyledDescriptionText>{value}</StyledDescriptionText>
        </>
      ),
    },
    {
      title: "",
      key: "action",
      width: "90px",
      render: (_, record) => (
        // <div style={{display: "flex", justifyContent: "end"}}>
        <ServiceListMenuOption
          serviceId={record.id}
          slug={record.slug}
          tinyUrl={record.tinyUrl}
          ordersInProgress={record.ordersInProgress}
          currentPage={currentPage}
        />
        // </div>
      ),
    },
  ];
  return (
    <Space size={24} direction="vertical" style={{display: "flex"}}>
      <Table
        columns={columns}
        dataSource={serviceData}
        scroll={{x: 100}}
        pagination={false}
        loading={isLoading}
      />
      <div>
        <Space size={12}>
          <Button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            size="small"
          >
            Previous
          </Button>
          <Button
            onClick={() => {
              if (!isPreviousData && Number(paginationMeta.next_page) !== 0) {
                setCurrentPage((prev) => prev + 1);
              }
            }}
            // Disable the Next Page button until we know a next page is available
            disabled={isPreviousData || Number(paginationMeta.next_page) === 0}
            size="small"
          >
            Next
          </Button>
        </Space>
      </div>
    </Space>
  );
}
